export default class AlEntityOptionLinksComponentController {

    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;
        this.translate = this.injector.get('$translate');

        this.initiated = false;
        this.showStore = false;
        this.allowedEntities = [
            'guestlist',
            'rsvp'
        ];

        this.objectTypeInformation = {
            'Time reserved': {
                defaultVisibleFields: {
                    'rsvp': [
                        'option.label',
                        'meta_start_time',
                        'meta_end_time'
                    ],
                    'guestlist': [
                        'contact.full_name',
                        'rsvp.code',
                        'option.label',
                        'meta_start_time',
                        'meta_end_time'
                    ]
                },
                defaultSort: {
                    meta_start_time: 'desc'
                }
            },
            'Day range bookings': {
                defaultVisibleFields: {
                    'rsvp': [
                        'option.label',
                        'meta_start_date',
                        'meta_end_date'
                    ],
                    'guestlist': [
                        'contact.full_name',
                        'rsvp.code',
                        'option.label',
                        'meta_start_date',
                        'meta_end_date'
                    ]
                },
                defaultSort: {
                    meta_start_time: 'desc'
                }
            }
        };

        this._initWatchers();
    }

    $postLink() {
        this._initStore();
        this.initiated = true;
    }

    _initStore() {
        if (!this.initiated || !this._isEntityValid() || !this._isObjectValid()) {
            return;
        }
        this.showStore = false;

        if (!this._isPrimaryValid()) {
            return;
        }

        this.store = this.injector.get('BoOptionsLinks').reset({
            listview: `${_.upperFirst(_.camelCase(this.entity))}${this.entityId}OptionLinksListView`,
            persist: false
        });

        this.store.commit('setSlug', this._getFpSlugForCurrentConfiguration());

        let curObjectTypeInformation = this._getObjectTypeInformation(this.object.type);
        if(!curObjectTypeInformation) {
            return;
        }

        this.store.commit('setTitle', this.object.label);
        this.store.commit('setSort', curObjectTypeInformation.defaultSort);
        this.store.commit('setVisible', curObjectTypeInformation.defaultVisibleFields[this.entity]);
        this.store.dispatch('loadWorkflows', 'bookable_objects::option-links-list');

        this.showStore = true;
    }

    _isEntityValid() {
        return !!this.entity && _.isString(this.entity) && this.allowedEntities.indexOf(this.entity) !== -1;
    }

    _isPrimaryValid() {
        return !!this.entityId && _.isInteger(this.entityId);
    }

    _isObjectValid() {
        return !!this.object && _.isObject(this.object);
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.entity;
        }, () => {
            this._initStore();
        });

        this.scope.$watch(() => {
            return this.entityId;
        }, () => {
            this._initStore();
        });

        this.scope.$watch(() => {
            return this.object;
        }, () => {
            this._initStore();
        }, true);
    }

    _getFpSlugForCurrentConfiguration() {
        let slug = 'bo/',
            objectId = this.object.id;

        switch (this.entity) {
            case 'rsvp':
                slug += `rsvps/${this.entityId}/${objectId}/option-links`;
                break;
            case 'guestlist':
                slug += `guestlists/${this.entityId}/${objectId}/option-links`;
                break;
            default:
                return false;
        }

        return slug;
    }

    _getObjectTypeInformation(objectType) {
        return _.get(this.objectTypeInformation, objectType, null);
    }
}

AlEntityOptionLinksComponentController.$inject = [
    '$injector',
    '$scope'
];



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/components/entity-option-links/controller.js